import { SegmentOption, GameSegmentType, StatsSegmentType, RevenueGroupItem } from '../types'

export const defaultConfigValue = {
  gacha: [],
  moba: [],
  br: [],
  soc: [],
  tops: [],
  customize: [],
  all: [],
};

export const GameSegmentOptions: SegmentOption<GameSegmentType>[] = [
  {
    text: 'dbi_benchmark_game_gacha',
    value: 'gacha',
    name: 'Gacha',
  },
  {
    text: 'dbi_benchmark_game_casual',
    value: 'casual',
    name: 'Causal'
  },
  {
    text: 'dbi_benchmark_game_slg',
    value: 'slg',
    name: 'SLG'
  },
  {
    text: 'dbi_benchmark_game_mmo',
    value: 'mmo',
    name: 'MMO'
  },
  {
    text: 'dbi_benchmark_game_shooter',
    value: 'shooter',
    name: 'Shooter'
  },
  {
    text: 'dbi_benchmark_game_sports',
    value: 'sports',
    name: 'Sports'
  },
  {
    text: 'dbi_benchmark_game_top',
    value: 'top',
    info: 'dbi_benchmark_tops_info',
    name: 'TOPs'
  },
  {
    text: 'dbi_benchmark_customized',
    value: 'customize_mobile',
    name: 'Customized'
  },
];

export const RevenueUnitsSegment: SegmentOption<string>[] = [
  {
    text: 'dbi_revenue',
    value: 'revenue',
  },
  {
    text: 'dbi_downloads',
    value: 'download',
  },
  {
    text: 'dbi_benchmark_avg_dau',
    value: 'dau',
  },
];

export const StatusSegmentOptions: SegmentOption<StatsSegmentType>[] = [
  {
    text: 'dbi_benchmark_kpi_data',
    value: 'kpi_data',
  },
  {
    text: 'dbi_benchmark_ral',
    value: 'player_activity',
  },
  {
    text: 'dbi_benchmark_social_channels',
    value: 'social_channels',
  },
  {
    text: 'dbi_benchmark_basic_info',
    value: 'basic_info',
  },
];

export const StatsFilterDefaultValue: { [key in StatsSegmentType]?: any} = {
  kpi_data: {
    time_basis: 'original',
    time_period: '1y~5y',
    metrics: ['revenue'],
    systems: ['Android', 'ios'],
    regions: ['global_wo_china']
  },
  player_activity: {
    regions: ['global'],
    systems: ['Android', 'ios'],
  },
  social_channels: {
    steam_source: ['ytg'],
    time_scale: ['lt']
  },
  basic_info: {}
}

export const yearList = [
  {name: 'Y1', value: '1y'},
  {name: 'Y2', value: '2y'},
  {name: 'Y3', value: '3y'},
  {name: 'Y4', value: '4y'},
  {name: 'Y5', value: '5y'},
  {name: 'Total', name_zh: '总量',value: 'total'}
]

export const monthList = [
  {name: 'M1', value: '1m'},
  {name: 'M2', value: '2m'},
  {name: 'M3', value: '3m'},
  {name: 'M4', value: '4m'},
  {name: 'M5', value: '5m'},
  {name: 'M6', value: '6m'},
  {name: 'M7', value: '7m'},
  {name: 'M8', value: '8m'},
  {name: 'M9', value: '9m'},
  {name: 'M10', value: '10m'},
  {name: 'M11', value: '11m'},
  {name: 'M12', value: '12m'},
  {name: 'Total', name_zh: '总量', value: 'total'}
]

export const MetricsSort = {
   revenue: 1,
   download: 2,
   dau: 3
}

export const StreamSourceSort = {
  twitch: 1,
  ytg: 2,
  facebook: 3
}

export const TimeScaleSort = {
  lt: 1,
  '365d': 2,
  '30d': 3
}


export const StatsFilterGroupConfig : { [key in StatsSegmentType]?: RevenueGroupItem[]} = {
  kpi_data: [
    {
      name: 'dbi_benchmark_time_basis',
      value: 'time_basis',
      type: 'radio',
      option: [
        {
          label: 'dbi_benchmark_original',
          value: 'original',
        },
        {
          label: 'dbi_benchmark_aligned_across_apps',
          value: 'aligned',
        },
        {
          label: 'dbi_benchmark_reorder_base',
          value: 'reordered',
          info: 'dbi_benchmark_reorder_base_info'
        },
      ],
    },
    {
      name: 'dbi_benchmark_time_period',
      value: 'time_period',
      type: 'radio',
      option: [
        {
          label: 'dbi_benchmark_m1_m12',
          value: '1m~12m',
        },
        {
          label: 'dbi_benchmark_y1_y5',
          value: '1y~5y',
        },
      ],
    },
    {
      name: 'dbi_label_metrics',
      value: 'metrics',
      type: 'checkbox',
      option: [
        {
          label: 'dbi_revenue',
          value: 'revenue',
        },
        {
          label: 'dbi_downloads',
          value: 'download',
        },
        {
          label: 'dbi_benchmark_avg_dau',
          value: 'dau',
        }
      ],
    },
    // {
    //   name: 'dbi_benchmark_system',
    //   value: 'system',
    //   option: [
    //     {
    //       label: 'dbi_benchmark_both',
    //       value: 'all',
    //     },
    //     {
    //       label: 'dbi_benchmark_ios',
    //       value: 'ios',
    //     },
    //     {
    //       label: 'dbi_benchmark_android',
    //       value: 'android',
    //     }
    //   ],
    // }
    {
      name: 'dbi_area_region',
      value: 'regions',
      type: 'region',
      option: [],
    }
  ],
  player_activity: [
    {
      name: 'dbi_area_region',
      value: 'regions',
      type: 'region',
      disabled: true,
      option: [],
    },
    // {
    //   name: 'dbi_benchmark_device',
    //   value: 'device',
    //   type: 'checkbox',
    //   option: [
    //     {
    //       label: 'dbi_benchmark_both',
    //       value: 'all',
    //     },
    //     {
    //       label: 'dbi_benchmark_ios',
    //       value: 'ios',
    //     },
    //     {
    //       label: 'dbi_benchmark_android',
    //       value: 'android',
    //     },
       
    //   ],
    // }
  ],
  social_channels: [ 

    {
      name: 'dbi_benchmark_stream_source',
      value: 'steam_source',
      type: 'checkbox',
      option: [
        {
          label: 'dbi_benchmark_twitch',
          value: 'twitch',
        },
        {
          label: 'dbi_benchmark_youtube',
          value: 'ytg',
        },
        {
          label: 'dbi_benchmark_facebook',
          value: 'facebook',
        },
      ],
    },
    {
      name: 'dbi_benchmark_time_scale',
      value: 'time_scale',
      type: 'checkbox',
      option: [
        {
          label: 'dbi_benchmark_lifetime',
          value: 'lt',
        },
        {
          label: 'dbi_benchmark_365d',
          value: '365d',
        },
        {
          label: 'dbi_benchmark_30d',
          value: '30d',
        },
      ],
    }
  ]
}

export const SocialChannelLabel = StatsFilterGroupConfig?.social_channels?.reduce((result, item)=> {
  item?.option?.forEach(config=> {
    result[config.value] = config.label;
  })
  return result;
}, {})

export const SocialChannelsFiledList = [
  {
    name: 'Avg Hours Watched',
    name_zh: '平均观看时长',
    value: 'avg_hours_watched',
    width: 210,
  },
  { name: 'Peak CCV', name_zh: '直播观众峰值', value: 'peak_ccv', width: 150 },
  { name: 'Avg CCV', name_zh: '直播观众平均值', value: 'avg_ccv', width: 130 },
  {
    name: 'Sum Airtime',
    name_zh: '总直播时长',
    value: 'sum_airtime',
    width: 145,
  },
]

export const PlayerActivityFiledList = [
  {
    name: 'Avg Retention D2',
    name_zh: '平均次留',
    value: 'avg_retention_d2',
    type: 'ratio',
    width: 190
  },
  {
    name: 'Avg Retention D3',
    name_zh: '平均3留',
    value: 'avg_retention_d3',
    type: 'ratio',
    width: 190
  },
  {
    name: 'Avg Retention D7',
    name_zh: '平均7留',
    value: 'avg_retention_d7',
    type: 'ratio',
    width: 190
  },
  {
    name: 'Avg Retention D15',
    name_zh: '平均15留',
    value: 'avg_retention_d15',
    type: 'ratio',
    width: 200
  },
  {
    name: 'Avg Retention D31',
    name_zh: '平均31留',
    value: 'avg_retention_d31',
    type: 'ratio',
    width: 200
  },
  {
    name: 'Avg Play Days',
    name_zh: '平均游玩天数',
    value: 'avg_play_days',
    type: 'ratio',
    width: 170
  },
  {
    name: 'ARPDAU($)',
    name_zh: '日活ARPU(美元)',
    value: 'arpdau',
    type: 'ratio',
    width: 170
  },
  {
    name: 'LTV($)',
    name_zh: 'LTV(美元)',
    value: 'ltv',
    type: 'ratio',
    width: 130
  }
]

export const GLOBAL_REGION = [
  {
    area_code: 'global',
    area_name_ch: '全球',
    area_name_en: 'Global',
  },
  {
    area_code: 'global_wo_china',
    area_name_ch: '全球（不包括中国大陆）',
    area_name_en: 'Global except China mainland',
  },
];





